import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';
import { isEmpty } from 'lodash';

import {
    Card,
    CardContent,
    Container,
    Grid,
    Typography,
    Divider,
    FormControlLabel,
    Radio,
    colors
} from '@material-ui/core';

import {
    ColorPicker,
    FieldError
} from '../../../common';

import {
    Form,
    Formik,
    Field
} from 'formik';

import {
    Switch,
    TextField,
    CheckboxWithLabel,
    RadioGroup
} from 'formik-material-ui';

import { PageContext } from '../PageContext';
import { PluginContext } from '../../../contexts';

import { MenuLayoutType, UserLoginType } from '../../../../helpers';

import { useTranslation } from "react-i18next";

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    sectionTitle: {
        color: "#7957d5"
    },
    content: {
        marginTop: theme.spacing(4)
    },
    field: {
        width: "100%"
    },
    progress: {
        color: "black"
    },
    pickerBox: {
        //marginLeft: "-6px"
    }
}));

export const StyleForm = ({
    formRef,
    errors,
    validationSchema,
    disabled,
    onBlur,
    onSubmit,
    ...props }) => {
    const classes = useStyles();

    const { t, i18n } = useTranslation();

    const {
        state
    } = useContext(PageContext);

    const {
        plugin
    } = useContext(PluginContext);

    const {
        settings,
    } = state;

    const getInitialValues = () => {
        return {
            appTitle: !isEmpty(settings) && settings.appTitle ? settings.appTitle : "",
            menuTitle: !isEmpty(settings) && settings.menuTitle ? settings.menuTitle : "",
            bundleId: !isEmpty(settings) && settings.bundleId ? settings.bundleId : "",
            versionNumber: !isEmpty(settings) && settings.versionNumber ? settings.versionNumber : "",
            shareAppIos: !isEmpty(settings) && settings.shareAppIos ? settings.shareAppIos : "",
            shareAppAndroid: !isEmpty(settings) && settings.shareAppAndroid ? settings.shareAppAndroid : "",
            enableAppMenu: !isEmpty(settings) && settings.enableAppMenu !== undefined ? settings.enableAppMenu : true,
            appMenuLayout: !isEmpty(settings) && settings.appMenuLayout ? settings.appMenuLayout : MenuLayoutType.Drawer,
            homeUrl: !isEmpty(settings) && settings.homeUrl ? settings.homeUrl : "",
            appPrimaryColor: !isEmpty(settings) && settings.appPrimaryColor ? settings.appPrimaryColor : "#7957d5",
            appSecondaryColor: !isEmpty(settings) && settings.appSecondaryColor ? settings.appSecondaryColor : "#7957d5",
            entryTextColor: !isEmpty(settings) && settings.entryTextColor ? settings.entryTextColor : "#000",
            entryBackgroundColor: !isEmpty(settings) && settings.entryBackgroundColor ? settings.entryBackgroundColor : "#fff",
            errorTextColor: !isEmpty(settings) && settings.errorTextColor ? settings.errorTextColor : "#f00",
            appTitleColor: !isEmpty(settings) && settings.appTitleColor ? settings.appTitleColor : "#fff",
            colorHeaderMenu: !isEmpty(settings) && settings.colorHeaderMenu ? settings.colorHeaderMenu : "#fff",
            menuTitleBackgroundColor: !isEmpty(settings) && settings.menuTitleBackgroundColor ? settings.menuTitleBackgroundColor : "#7957d5",
            menuItemsBackgroundColor: !isEmpty(settings) && settings.menuItemsBackgroundColor ? settings.menuItemsBackgroundColor : "#fff",
            menuItemsTextColor: !isEmpty(settings) && settings.menuItemsTextColor ? settings.menuItemsTextColor : "#515151",
            menuBackgroundColor: !isEmpty(settings) && settings.menuBackgroundColor ? settings.menuBackgroundColor : "#fff",
            useLightStatusBar: !isEmpty(settings) && settings.useLightStatusBar !== undefined ? settings.useLightStatusBar : false,
            useUserLogin: !isEmpty(settings) && settings.useUserLogin !== undefined ? settings.useUserLogin : false,
            userLoginType: !isEmpty(settings) && settings.userLoginType ? settings.userLoginType : UserLoginType.Always,

            // This field is readonly and the purpose of this field is to show the user 
            // the current site domain to use during the purchase process
            licenseId: plugin.siteUid
        };
    }

    const submitClickHandler = (values, actions) => {
        if (onSubmit) onSubmit(values, () => actions.setSubmitting(false));
    }

    return (
        <Card className={clsx(classes.root, props.className)}>
            <CardContent>
                <Container maxWidth="lg" className={classes.content}>
                    <Formik
                        enableReinitialize
                        initialValues={getInitialValues()}
                        onSubmit={submitClickHandler}
                        innerRef={formRef}
                        validationSchema={validationSchema}
                        validateOnChange={false}
                        validateOnBlur={true}
                        validate={(values) => {
                            if (onBlur) onBlur(values);
                        }}>
                        {(props) => {
                            const {
                                values,
                                isSubmitting,
                                handleSubmit,
                                setFieldValue,
                            } = props;
                            return (
                                <Form noValidate autoComplete="off">
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <Typography className={classes.sectionTitle} variant="h6">
                                                {t("LabelInfoGeneral")}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                className={classes.field}
                                                name="menuTitle"
                                                type="text"
                                                variant="outlined"
                                                label={t("LabelMenuTitle")}
                                                helperText={t("HelperMenuTitle")}
                                                component={TextField}
                                                disabled={disabled}
                                            />
                                            <FieldError
                                                name="menuTitle"
                                                errors={errors}
                                            />
                                        </Grid>

                                     <Grid item xs={12}>
                                        <Typography className={classes.sectionTitle} variant="h6">
                                           {t("LabelInfoSharing")}
                                        </Typography>
                                     </Grid>
                                     <Grid item xs={12}>
                                        <Field
                                           className={classes.field}
                                           name="shareAppIos"
                                           type="text"
                                           variant="outlined"
                                           label={t("LabelShareAppIos")}
                                           helperText={t("HelperShareAppIos")}
                                           component={TextField}
                                           disabled={disabled}
                                        />
                                        <FieldError
                                           name="shareAppIos"
                                           errors={errors}
                                        />
                                     </Grid>
                                     <Grid item xs={12}>
                                        <Field
                                           className={classes.field}
                                           name="shareAppAndroid"
                                           type="text"
                                           variant="outlined"
                                           label={t("LabelShareAppAndroid")}
                                           helperText={t("HelperShareAppAndroid")}
                                           component={TextField}
                                           disabled={disabled}
                                        />
                                        <FieldError
                                           name="shareAppAndroid"
                                           errors={errors}
                                        />
                                        {/* <Divider variant="fullWidth" style={{ marginTop: "24px", marginBottom: "0px" }} /> */}
                                     </Grid>

                                        {/*
                                           <Grid item xs={12}>
                                               <Typography className={classes.sectionTitle} variant="h6">
                                                   {t("LabelInfoAuthentication")}
                                               </Typography>
                                           </Grid>
                                           <Grid item xs={12}>
                                               <Field
                                                   type="checkbox"
                                                   name="useUserLogin"
                                                   component={CheckboxWithLabel}
                                                   Label={{ label: t("LabelUseUserLogin") }}
                                                   disabled={disabled}
                                               />
                                               <br />
                                               <Typography variant="caption" style={{ marginLeft: "16px" }}>
                                                   {t("HelperUseUserLogin")}
                                               </Typography>
                                           </Grid>
                                           {values.useUserLogin &&
                                               <Grid item xs={12}>
                                                   <Field component={RadioGroup} name="userLoginType">
                                                       <FormControlLabel
                                                           value={UserLoginType.Always}
                                                           control={<Radio disabled={isSubmitting} />}
                                                           label={t("LabelLoginAlways")}
                                                           disabled={disabled}
                                                       />
                                                       <FormControlLabel
                                                           value={UserLoginType.Action}
                                                           control={<Radio disabled={isSubmitting} />}
                                                           label={t("LabelLoginAction")}
                                                           disabled={disabled}
                                                       />
                                                       <FormControlLabel
                                                           value={UserLoginType.Code}
                                                           control={<Radio disabled={isSubmitting} />}
                                                           label={t("LabelLoginCode")}
                                                           disabled={disabled}
                                                       />
                                                   </Field>
                                               </Grid>
                                          }
                                        */}
                                        
                                        <Grid item xs={12}>
                                            <Typography className={classes.sectionTitle} variant="h6">
                                                {t("LabelInfoMenuAndNavigation")}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                type="checkbox"
                                                name="enableAppMenu"
                                                component={CheckboxWithLabel}
                                                Label={{ label: t("LabelUseNativeAppSideMenu") }}
                                                disabled={disabled}
                                            />
                                            <br />
                                            <Typography variant="caption" style={{ marginLeft: "16px" }}>
                                                {t("HelperUseNativeAppSideMenu")}
                                            </Typography>
                                        </Grid>
                                        {!values.enableAppMenu &&
                                            <Grid item xs={12}>
                                                <Field
                                                    className={classes.field}
                                                    name="homeUrl"
                                                    type="text"
                                                    variant="outlined"
                                                    label={t("LabelHomeUrl")}
                                                    helperText={t("HelperHomeUrl")}
                                                    component={TextField}
                                                    disabled={disabled}
                                                />
                                                <FieldError
                                                    name="homeUrl"
                                                    errors={errors}
                                                />
                                                {/* <Divider variant="fullWidth" style={{ marginTop: "32px", marginBottom: "0px" }} /> */}
                                            </Grid>
                                        }
                                        {values.enableAppMenu &&
                                            <Grid item xs={12}>
                                                <Field component={RadioGroup} name="appMenuLayout">
                                                    <FormControlLabel
                                                        value={MenuLayoutType.Drawer}
                                                        control={<Radio disabled={isSubmitting} />}
                                                        label={t("LabelDrawerMenuLayout")}
                                                        disabled={disabled}
                                                    />
                                                    <FormControlLabel
                                                        value={MenuLayoutType.Tiles}
                                                        control={<Radio disabled={isSubmitting} />}
                                                        label={t("LabelTilesMenuLayout")}
                                                        disabled={disabled}
                                                    />
                                                    <FormControlLabel
                                                        value={MenuLayoutType.Tabs}
                                                        control={<Radio disabled={isSubmitting} />}
                                                        label={t("LabelTabsMenuLayout")}
                                                        disabled={disabled}
                                                    />
                                                </Field>
                                                {/* <Divider variant="fullWidth" style={{ marginTop: "32px", marginBottom: "0px" }} /> */}
                                            </Grid>
                                        }
                                        <Grid item xs={12}>
                                            <Typography className={classes.sectionTitle} variant="h6">
                                                {t("LabelInfoStyleAndAppearance")}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                type="checkbox"
                                                name="useLightStatusBar"
                                                component={CheckboxWithLabel}
                                                Label={{ label: t("LabelUseLightStatusBar") }}
                                                disabled={disabled}
                                            />
                                            <br />
                                            <Typography variant="caption" style={{ marginLeft: "16px" }}>
                                                {t("HelperUseLightStatusBar")}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs="auto" style={{ minWidth: 360 }}>
                                            <Typography>
                                                {t("LabelAppPrimaryColor")}
                                            </Typography>
                                            <div className={classes.pickerBox}>
                                                <ColorPicker
                                                    value={values.appPrimaryColor}
                                                    disabled={disabled}
                                                    onChange={(x) => setFieldValue("appPrimaryColor", x.hex, true)}
                                                />
                                            </div>
                                        </Grid>
                                        <Grid item xs="auto" style={{ minWidth: 360 }}>
                                            <Typography>
                                                {t("LabelAppSecondaryColor")}
                                            </Typography>
                                            <div className={classes.pickerBox}>
                                                <ColorPicker
                                                    value={values.appSecondaryColor}
                                                    disabled={disabled}
                                                    onChange={(x) => setFieldValue("appSecondaryColor", x.hex, true)}
                                                />
                                            </div>
                                        </Grid>
                                        <Grid item xs="auto" style={{ minWidth: 360 }}>
                                            <Typography>
                                                {t("LabelEntryTextColor")}
                                            </Typography>
                                            <div className={classes.pickerBox}>
                                                <ColorPicker
                                                    value={values.entryTextColor}
                                                    disabled={disabled}
                                                    onChange={(x) => setFieldValue("entryTextColor", x.hex, true)}
                                                />
                                            </div>
                                        </Grid>
                                        <Grid item xs="auto" style={{ minWidth: 360 }}>
                                            <Typography>
                                                {t("LabelEntryBackgroundColor")}
                                            </Typography>
                                            <div className={classes.pickerBox}>
                                                <ColorPicker
                                                    value={values.entryBackgroundColor}
                                                    disabled={disabled}
                                                    onChange={(x) => setFieldValue("entryBackgroundColor", x.hex, true)}
                                                />
                                            </div>
                                        </Grid>
                                        <Grid item xs="auto" style={{ minWidth: 360 }}>
                                            <Typography>
                                                {t("LabelErrorTextColor")}
                                            </Typography>
                                            <div className={classes.pickerBox}>
                                                <ColorPicker
                                                    value={values.errorTextColor}
                                                    disabled={disabled}
                                                    onChange={(x) => setFieldValue("errorTextColor", x.hex, true)}
                                                />
                                            </div>
                                        </Grid>
                                        {values.appMenuLayout == MenuLayoutType.Drawer &&
                                            <Grid item xs="auto" style={{ minWidth: 360 }}>
                                                <Typography>
                                                    {t("LabelMenuTitleBackgroundColor")}
                                                </Typography>
                                                <div className={classes.pickerBox}>
                                                    <ColorPicker
                                                        value={values.menuTitleBackgroundColor}
                                                        disabled={disabled}
                                                        onChange={(x) => setFieldValue("menuTitleBackgroundColor", x.hex, true)}
                                                    />
                                                </div>
                                            </Grid>
                                        }
                                        {(values.appMenuLayout == MenuLayoutType.Tiles
                                            || values.appMenuLayout == MenuLayoutType.Tabs) &&
                                            <Grid item xs="auto" style={{ minWidth: 360 }}>
                                                <Typography>
                                                    {t("LabelMenuBackgroundColor")}
                                                </Typography>
                                                <div className={classes.pickerBox}>
                                                    <ColorPicker
                                                        value={values.menuBackgroundColor}
                                                        disabled={disabled}
                                                        onChange={(x) => setFieldValue("menuBackgroundColor", x.hex, true)}
                                                    />
                                                </div>
                                            </Grid>
                                        }
                                        {(values.appMenuLayout == MenuLayoutType.Drawer
                                            || values.appMenuLayout == MenuLayoutType.Tiles) &&
                                            <Grid item xs="auto" style={{ minWidth: 360 }}>
                                                <Typography>
                                                    {t("LabelMenuItemsBackgroundColor")}
                                                </Typography>
                                                <div className={classes.pickerBox}>
                                                    <ColorPicker
                                                        value={values.menuItemsBackgroundColor}
                                                        disabled={disabled}
                                                        onChange={(x) => setFieldValue("menuItemsBackgroundColor", x.hex, true)}
                                                    />
                                                </div>
                                            </Grid>
                                        }
                                        <Grid item xs="auto" style={{ minWidth: 360 }}>
                                            <Typography>
                                                {t("LabelAppTitleColor")}
                                            </Typography>
                                            <div className={classes.pickerBox}>
                                                <ColorPicker
                                                    value={values.appTitleColor}
                                                    disabled={disabled}
                                                    onChange={(x) => setFieldValue("appTitleColor", x.hex, true)}
                                                />
                                            </div>
                                        </Grid>
                                        {values.appMenuLayout == MenuLayoutType.Drawer &&
                                            <Grid item xs="auto" style={{ minWidth: 360 }}>
                                                <Typography>
                                                    {t("LabelColorHeaderMenu")}
                                                </Typography>
                                                <div className={classes.pickerBox}>
                                                    <ColorPicker
                                                        value={values.colorHeaderMenu}
                                                        disabled={disabled}
                                                        onChange={(x) => setFieldValue("colorHeaderMenu", x.hex, true)}
                                                    />
                                                </div>
                                            </Grid>
                                        }
                                        <Grid item xs="auto" style={{ minWidth: 360 }}>
                                            <Typography>
                                                {t("LabelMenuItemsTextColor")}
                                            </Typography>
                                            <div className={classes.pickerBox}>
                                                <ColorPicker
                                                    value={values.menuItemsTextColor}
                                                    disabled={disabled}
                                                    onChange={(x) => setFieldValue("menuItemsTextColor", x.hex, true)}
                                                />
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Form>
                            );
                        }}
                    </Formik>
                </Container>
            </CardContent>
        </Card >
    );
}